import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '@/components/PageLayout';
import { Seo } from '@/components/Seo';
import {
  DEMO_COMING_SOON,
  DEMO_COMING_SOON_MESSAGE,
  ROUTES,
} from '@/constants/site';

const DESCRIPTION =
  'Nova 데모 시뮬레이션. 레지스트리 아티팩트 분석부터 Nova AI 어시스턴트 응답까지 실제 화면으로 체험해보세요.';

export default function DemoPage() {
  const navigate = useNavigate();

  // 주소창으로 직접 들어온 경우 — 알리고 홈으로 되돌린다.
  // 데모 화면이 확정되면 constants/site.js 의 DEMO_COMING_SOON 만 끄면 된다
  useEffect(() => {
    if (!DEMO_COMING_SOON) return;
    window.alert(DEMO_COMING_SOON_MESSAGE);
    navigate(ROUTES.index, { replace: true });
  }, [navigate]);

  if (DEMO_COMING_SOON) return null;

  return (
    <>
      <Seo
        title="Demo"
        ogTitle="Demo — AI와 함께 시작하는 분석 체험 | Nova"
        description={DESCRIPTION}
        path={ROUTES.demo}
      />
      <PageLayout bodyClass="page-demo">
        <section aria-labelledby="try-title" className="bg-white py-20">
          <div className="inner flex flex-col gap-10">
            {/* Try 배너 — 1280×280 / 반경 16 / bg #21272a */}
            <div className="relative h-[280px] w-full overflow-hidden rounded-2xl bg-fg-strong shadow-[4px_4px_20px_rgba(44,41,57,0.5)]">
              <img
                src="/assets/images/demo-try-bg.svg"
                alt=""
                aria-hidden="true"
                className="demo-try-bg pointer-events-none absolute -top-[140px] -right-[13px] w-[1808px] max-w-none -scale-x-100"
              />

              <img
                src="/assets/images/demo-try-screen.png"
                alt="Nova 대시보드 미리보기"
                width="1200"
                height="690"
                fetchPriority="high"
                className="demo-try-screen pointer-events-none absolute top-[45px] -right-[85px] h-[345px] w-[600px] max-w-none object-cover shadow-[11px_19px_20px_rgba(0,0,0,0.4)]"
              />

              <div className="relative flex h-full flex-col justify-center gap-5 pl-[49px]">
                <h1 id="try-title" className="text-[42px] leading-[1.1] font-bold text-white">
                  Try.
                </h1>
                <p className="text-[24px] leading-[1.4] font-semibold tracking-[-0.48px] text-white">
                  AI와 함께 빠르고 정확한 분석을 시작해보세요.
                </p>
              </div>
            </div>

            <div className="flex w-full flex-col items-center gap-10 py-10">
              <h2 id="sim-title" className="flex flex-col items-center gap-1 px-2 py-3">
                <span className="text-[28px] leading-none font-semibold tracking-[-1.08px] text-fg-strong md:text-[36px]">
                  Demo Simulation
                </span>
                <span className="title-glow" aria-hidden="true" />
              </h2>

              {/* 시뮬레이션 화면 자리 — 이미지 교체 예정 (1200×718) */}
              <div className="w-full rounded-3xl bg-white p-4 shadow-[2px_4px_6px_rgba(102,112,128,0.1)] md:p-10">
                <div
                  data-slot="demo-simulation"
                  className="flex aspect-[1200/718] w-full flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-line-strong bg-surface-muted text-center"
                >
                  <p className="text-[18px] font-semibold text-fg-body">
                    Demo Simulation 이미지 자리
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </PageLayout>
    </>
  );
}
